import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 * @todo use Stack for stacked items?
 * @todo create InlineStack component for inline stacks eg flex?
 */
const Buttons = ({ data, className, ...rest } = {}) => {
  return <div className={classNames(className, "pb-buttons")} {...rest} />;
};

const propTypes = {
  data: PropTypes.shape({
    appearance: PropTypes.oneOf(["inline", "stacked"]).isRequired,
  }),
  className: PropTypes.string,
};

Buttons.propTypes = propTypes;

export default Buttons;
